module.exports = __webpack_public_path__ + "img/img_install_01.79943ae1.jpg";